<template>
  <div class="email-test">
    <EmailVisualEditor v-model="doc" />
  </div>
</template>

<style>

</style>
<script>
import EmailVisualEditor from "../components/visualEditor/email-visual-editor.vue";

export default {
    name: 'EmailTest',
    components: { EmailVisualEditor },
    data() {
      return {
        doc: null,
      };
    },
}
</script>

<style scoped>
.email-test {
  padding: 12px;
}
</style>